/**
 * 판매 상태 일곱 — 백엔드 E_SALES_ORDER_STATUSES 와 같은 철자.
 * 따로 둔 까닭: inventory-api(실물 줄의 sales_status)와 sales-order-api 가 둘 다 쓰는데,
 * sales-order-api 가 inventory-api 를 가져오므로 서로 값을 가져오면 모듈이 고리를 이룬다(2026-11-04).
 */
export const E_SALES_ORDER_STATUSES = ['preparing', 'confirmed', 'ordered', 'setup_done', 'dispatched', 'closed', 'cancelled'] as const;
export type  ESalesOrderStatus      = typeof E_SALES_ORDER_STATUSES[number];
